import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-terms-and-condition',
    templateUrl: './terms-and-condition.component.html',
    styleUrls: ['./terms-and-condition.component.css'],
    standalone: true
})
export class TermsAndConditionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
